import React, { memo } from 'react';
import { Box } from '@mui/material';
import {
  TimelineHeaderContainer,
  DoctorNameColumn,
  TimeAxisContainer,
  TimeLabel,
} from '../../MonthlyDoctorsShift.styles';
import { useTimelinePosition } from '../../hooks/useTimelinePosition';

/**
 * TimelineHeader Props
 */
interface TimelineHeaderProps {
  /** 日付（オプション：日付表示用） */
  date?: string;
}

/**
 * タイムラインヘッダーコンポーネント
 *
 * @description
 * 07:00〜22:00の時間軸ヘッダーを表示する。
 *
 * @param {TimelineHeaderProps} props - コンポーネントProps
 * @returns {React.ReactElement} タイムラインヘッダー
 *
 * @example
 * <TimelineHeader date="2025-01-15" />
 */
const TimelineHeader: React.FC<TimelineHeaderProps> = memo(({ date }) => {
  const { getTimeLabels } = useTimelinePosition();
  const timeLabels = getTimeLabels();

  return (
    <TimelineHeaderContainer>
      {/* 日付列ヘッダー */}
      <DoctorNameColumn>
        <Box sx={{ fontWeight: 'medium' }}>日付</Box>
      </DoctorNameColumn>

      {/* 時間軸 */}
      <TimeAxisContainer>
        {timeLabels.map((label) => (
          <TimeLabel key={label}>{label}</TimeLabel>
        ))}
      </TimeAxisContainer>
    </TimelineHeaderContainer>
  );
});

TimelineHeader.displayName = 'TimelineHeader';

export { TimelineHeader };
